import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/first-order': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M12.9 229.2C13 229.1 13.1 228.9 13.2 228.8 13.2 228.9 13.2 229.1 13.1 229.2H12.9zM224 96.6C216.9 96.6 209.4 97.2 202.6 98.3L206.3 165.7 184.3 101.7C170 105.4 156.6 111.1 144.3 118.3L173.7 179.7 128.6 128.8C117.2 137.7 106.9 147.9 98 159.7L148.6 205.1 87.5 175.4C80.4 187.7 74.6 201.1 70.9 215.4L135.2 238 67.2 234C66.3 241.1 65.8 248.6 65.8 256S66.4 270.6 67.2 277.7L134.9 273.7 70.9 296.3C74.6 310.6 80.3 324 87.5 336.6L148.6 306.9 97.7 352C106.6 363.7 116.8 374.3 128.6 382.9L173.5 332 144 393.4C156.3 400.8 169.7 406.5 184 410.3L206.3 345.7 202.3 413.7C209.4 414.8 216.9 415.4 224 415.4 231.4 415.4 238.6 414.8 245.7 413.7L241.7 345.1 264.3 410.2C278.6 406.2 292 400.8 304.3 393.3L274.9 332 319.8 382.9C331.5 374 341.8 363.8 350.4 352L299.8 306.9 360.9 336.3C368 324 373.8 310.6 377.5 296L313.5 273.7 380.9 277.7C382 270.6 382.3 263.4 382.3 256S382 241.1 380.9 234L313.2 238 377.2 215.7C373.5 201.4 368.1 187.7 360.6 175.4L299.7 205.1 350.3 159.7C341.4 148 331.2 137.7 319.7 128.8L274.6 179.7 304 118.6C291.7 111.2 278.3 105.5 264 101.7L241.7 166 245.7 98.3C238.6 97.1 231.4 96.6 224 96.6zM443.4 128V384L224 512 4.6 384V128L224 0 443.4 128zM426.3 138.3L224 20.9 21.7 138.3V373.4L224 491.1 426.3 373.4V138.3zM224 37.1L411.7 146.5V365.4L224 474.9 36.3 365.4V146.6L224 37.1zM224 88C131.7 88 57.1 163.1 57.1 256 57.1 348.6 131.7 423.7 224 423.7 316 423.7 390.9 348.6 390.9 256 390.9 163.1 316 88 224 88z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/first-order.js
// module id = 6ANm
// module chunks = 144